import * as types from "./types";
import {
    getJournalEntryLineAxios, 
    getJournalEntryLineIDAxios,
    deleteJournalEntryLineAxios,
    postJournalEntryLineAxios,
    putJournalEntryLineAxios,
    postJournalEntryLinesAxios,
} from "./services";

export async function getJournalEntryLineListAction({commit}) {
    commit(types.LOADING_JOURNALENTRYLINE, true);
    try {
        const {data} = await getJournalEntryLineAxios();
        commit(types.GET_JOURNALENTRYLINE_LIST, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_JOURNALENTRYLINE, false);
    }
   
}

export async function getJournalEntryLineIDAction({commit},payload) {
    commit(types.LOADING_JOURNALENTRYLINE, true);
    try {
        const {data} = await getJournalEntryLineIDAxios(payload);
        commit(types.GET_JOURNALENTRYLINE_ID, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_JOURNALENTRYLINE, false);
    }
}

export async function removeJournalEntryLineAction({commit}, payload) {
    commit(types.LOADING_JOURNALENTRYLINE, true);
    try {
        await deleteJournalEntryLineAxios(payload);
        commit(types.REMOVE_JOURNALENTRYLINE, payload);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_JOURNALENTRYLINE, false);
    }
}

export async function addJournalEntryLineAction({ commit }, payload) {
    commit(types.LOADING_JOURNALENTRYLINE, true);
    try {
      const { data } = await postJournalEntryLineAxios(payload);
      payload.id = data.result.id;
      commit(types.ADD_JOURNALENTRYLINE, payload);
    } catch (e) {
   
      throw e;
    } finally {
      commit(types.LOADING_JOURNALENTRYLINE, false);
    }
  }

  export async function addMultipleJournalEntryLineAction({ commit }, payload) {
    commit(types.LOADING_JOURNALENTRYLINE, true);
    try {
      const { data } = await postJournalEntryLinesAxios(payload);
      payload.id = data.result.id;
      commit(types.ADD_JOURNALENTRYLINE, payload);
    } catch (e) {
   
      throw e;
    } finally {
      commit(types.LOADING_JOURNALENTRYLINE, false);
    }
  }

  export async function updateJournalEntryLineAction({ commit }, payload) {
    commit(types.LOADING_JOURNALENTRYLINE, true);
    try {
      await putJournalEntryLineAxios(payload);
      commit(types.UPDATE_JOURNALENTRYLINE, payload);
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_JOURNALENTRYLINE, false);
    }
  }